//#region src/kiosk_network_interface.ts
var KioskNetworkInterface = /* @__PURE__ */ function(KioskNetworkInterface) {
	KioskNetworkInterface[KioskNetworkInterface["NA"] = 0] = "NA";
	KioskNetworkInterface[KioskNetworkInterface["WiFi"] = 1] = "WiFi";
	KioskNetworkInterface[KioskNetworkInterface["Ethernet"] = 2] = "Ethernet";
	return KioskNetworkInterface;
}(KioskNetworkInterface || {});
//#endregion
export { KioskNetworkInterface };

//# sourceMappingURL=kiosk_network_interface.js.map